declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, SaveCounsellingActivityRequest, CounsellingPlanController, CounsellingPlanRequest, CounsellingActivitiesByTimeController, CounsellingActivitiesByTimeRequest } from '../../../../../models/actor/actor';
import { ActorService } from '../../../../../services/actor.service';
import { DBOperation } from '../../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';
import { Time } from '@angular/common';

@Component({
  selector: 'activitymonitoringmodal',
  templateUrl: './activitymonitoring.modal.html',
  styleUrls: ['./activitymonitoring.modal.scss']
})

export class NgbActivityMonitoringModal implements OnInit {


  @Input() ActorDocCode;
  @Input() Code: number;
  @Input() DownloadActorImageFileExtension: string;
  @Input() DownloadActorImageFile: string;
  @Input() CurrentEditCounsellingActivityRequest: SaveCounsellingActivityRequest;
  @Input() CanEdit: number;
  @Input() CanShow: number;
  @Input() ADate: string;
  @Input() Time: string;
  @Input() CreatedUserName: string;
  @Input() AssignedToName: string;

  DOB: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  StartDate: NgbDateStruct;
  ActivityDate: NgbDateStruct;
  ActualActivityDate: NgbDateStruct;
  ActualActivityTime: Time;
  ActivityTime: Time;
  RecommendedPackage: string;
  Doctor: string;
  PackageCost: number;
  SelectEmi: boolean;
  Concerns: string;
  AddRemarks: string;
  file: File;
  fileList: FileList;



  FileExtension: string = "";
  MaritalStatus: string;
  JobType: string;
  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  public isvisible = true;

  DocFriendlyName: string = "";
  //CurrentCounsellingActivitiesByTimeController: CounsellingActivitiesByTimeController;
  //CurrentCounsellingActivitiesByTimeRequest: CounsellingActivitiesByTimeRequest;
  
  //LoadPatients() {
  //  this.CurrentCounsellingActivitiesByTimeRequest = new CounsellingActivitiesByTimeRequest();
  //  this.CurrentCounsellingActivitiesByTimeRequest.PlanCode = this.Code;
  //  this.CurrentCounsellingActivitiesByTimeRequest.ActorCode = 0;
  //  this.CurrentCounsellingActivitiesByTimeRequest.ConditionalOperator = 30;
    
  
    
  //  this.CurrentCounsellingActivitiesByTimeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.GetCounsellingActivitiesByTimeController();
  //}
  
  //GetCounsellingActivitiesByTimeController() {
  //  this.StartRefreshing();


  //  this.actorservice.GetCounsellingActivitiesByTimeController(this.CurrentCounsellingActivitiesByTimeRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;
  //        //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
  //        //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
  //        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );
  //}
  CurrentCounsellingPlanController: CounsellingPlanController[];
  CurrentCounsellingPlanRequest: CounsellingPlanRequest;
  LoadCounselling() {
    
    this.CurrentCounsellingPlanRequest = new CounsellingPlanRequest();
      this.CurrentCounsellingPlanRequest.ActorCode = "";
      this.CurrentCounsellingPlanRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    //this.CurrentCounsellingPlanRequest.ConditionalOperator = 10;
    this.CurrentCounsellingPlanRequest.PlanCode = this.Code;
    this.CurrentCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCounsellingPlanController();
  }
  GetCounsellingPlanController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetCounsellingPlanController(this.CurrentCounsellingPlanRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCounsellingPlanController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  @ViewChild('f') IdentitiesDocForm: NgForm;
  public UploadActorDoc: any;

  public CanDownLoadActorDoc: number

  public CanNurseView: number =0 ;



  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
    this.LoadCounselling();
    //this.LoadPatients();
    if (this.CurrentEditCounsellingActivityRequest.ActivityDate != null) {
      var SValidFrom = new Date(this.CurrentEditCounsellingActivityRequest.ActivityDate);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.ActivityDate >1990');
        this.ActivityDate = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }
    if (this.CurrentEditCounsellingActivityRequest.ActualActivityDate != null) {
      var SValidFrom = new Date(this.CurrentEditCounsellingActivityRequest.ActualActivityDate);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.ActualActivityDate >1990');
        this.ActualActivityDate = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }

    

  }

  onSubmit() {
 this.isvisible = false;
    this.CurrentEditCounsellingActivityRequest.ActivityDate = new Date(this.parserFormatter.format(this.ActivityDate));
    this.CurrentEditCounsellingActivityRequest.ActualActivityDate = new Date(this.parserFormatter.format(this.ActualActivityDate));
    //this.CurrentEditCounsellingPlanRequest.ActorCode = this.ActorCode;
    this.CurrentEditCounsellingActivityRequest.ConditionalOperator = 20;
    //this.CurrentEditCounsellingActivityRequest.CounsellingActivityCode = 10;
  


    this.actorservice.SaveCounsellingActivity(this.CurrentEditCounsellingActivityRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  

  
 
 
  
private stopRefreshing() {
  this.loaderService.displayLoader(false);
  this.isRequesting = false;
}
  private StartRefreshing() {
  this.loaderService.displayLoader(true);
  this.isRequesting = true;
  }
  editfollicular() {
    this.router.navigate(['nurse/editfollicular']);
    this.activeModal.close();
  }
}





  //GetActorDocController() {
  //  this.StartRefreshing();
  //  this.docservice.GetActorDocController(this.CurrentActorDocRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentActorDocController = this.ApiResData.Result;
  //        this.initGridButton();
  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //    (error) => {

  //      if (error == "401 - Unauthorized") {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();



  //      }
  //      else {
  //        alertFunctions.AlertParamEr(error);
  //        this.stopRefreshing();
  //      }
  //    }


  //    );

  //}

  

  /////////////////////////



  //

  // https://www.codeproject.com/Articles/1195569/Angular-Data-Grid-with-Sorting-Filtering-Export-to
  // dbops: DBOperation;
  //Grid Vars start














  /////////////////////////

